export const TITLE_PAGE ='Orientación vocacional y ocupacional'